import React from 'react'
import { StateProvider } from '../stores/pages'
import Content from './PagesEditor/Content'
import Sidebar from './PagesEditor/Sidebar'
import ThemeEditorSidebar from './PagesEditor/ThemeEditorSidebar'
import PageActions from './PagesEditor/PageActions'
import PagePreview from './PagesEditor/PagePreview'
import PageStatus from './PagesEditor/PageStatus'
import PageForm from './PagesEditor/PageForm'
import PageBlocks from './PagesEditor/PageBlocks'
import Publish from './PagesEditor/Publish'

export default function Share(props) {
  return (
    <StateProvider {...props}>
      <Sidebar>
        <PageForm>
          <PageBlocks />
          <ThemeEditorSidebar />
          {props.showPublish && <Publish />}
        </PageForm>
      </Sidebar>
      <Content>
        <PageActions />
        <PagePreview />
        <PageStatus />
      </Content>
    </StateProvider>
  )
}
